import React, { useEffect, useState } from "react";
import FadeInComponent from "./FadeIn";
import { useController } from "react-hook-form";
import CheckBox from "./CheckBox";
import useWindowSize from "../../utils/hooks/useWindowSize";


const CategoryCheck = ({ name, control, error }) => {
    const windowSize = useWindowSize();
    const [resetArtist, setResetArtist] = useState(false);
    const [resetRecruiter, setResetRecruiter] = useState(false);
    const { field } = useController({
        name,
        control,
        defaultValue: ""
    });

    const isMobileLandscape = windowSize.x > windowSize.y && windowSize.x <= 915;

    const handleChange = (name, checked) => {
        let value = field.value; 
        if (name === "artist") {
            setResetRecruiter(!resetRecruiter);
        } else {
            setResetArtist(!resetArtist);
        }
        if (value.includes(name)) field.onChange(value.filter((a) => a !== name));
        else field.onChange([ ...value, name ]);
    };

    return (
        <FadeInComponent>
            <div className="category-container">
                <label style={{ fontSize: 12, alignSelf: "flex-start", marginTop: 4 }}>Category</label>
                <div
                    className="category-select-container"
                    style={isMobileLandscape ? { flexDirection: "row" } : {}}>
                    <CheckBox
                        key={`artist-${resetArtist}`}
                        name="artist"
                        placeholder="Artist"
                        value={field.value.includes("artist")}
                        onChange={handleChange}
                    />
                    <CheckBox
                        key={`recruiter-${resetRecruiter}`}
                        name="recruiter"
                        placeholder="Recruiter"
                        value={field.value.includes("recruiter")}
                        onChange={handleChange}
                    />
                </div>
                {error && <div className="error">{error}</div>}
            </div>
        </FadeInComponent>
    );
};

export default CategoryCheck;
